<!--
 * @Description: 云途销售线索 - 编辑页面
 * @Author: mdb
 * @Date: 2022-07-16 10:45:39
 * @LastEditTime: 2022-11-23 16:58:53
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <DetailForm ref="detailFormRef" type="edit" isEdit v-model:value="dataForm" :resetValue="initForm" />
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { reactive, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import DetailForm from './components/DetailForm.vue'
import { salesClueDetail } from '@/api/yuntuSales/clueManage'
import type { LbuSalesClueEditParams } from '@/typings/api/clueManage'
const route = useRoute()

const initForm: LbuSalesClueEditParams.RootObject = reactive({
  contact: {},
  business: { saleInfo: [{}], demandInfo: [{}], erpInfo: [{}] },
  visitAddress: [{}]
})
const dataForm = reactive<LbuSalesClueEditParams.RootObject>(cloneDeep(initForm))

onBeforeMount(() => {
  salesClueDetail({ clueId: route.query.clueId as string }).then((res) => {
    if (res.data.visitAddress == null || res.data.visitAddress?.length === 0) {
      res.data.visitAddress = [{}]
    }
    Object.assign(initForm, res.data)
    Object.assign(dataForm, res.data)
  })
})
</script>
<script lang="ts">
export default { name: 'DcCosLbuSalesClueEdit' }
</script>

<style scoped></style>
